import classNames from 'classnames';
import React from 'react';

import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Checkbox as MuiCheckbox,
  makeStyles,
} from '@material-ui/core';

import { useErrorStyles } from './form.styles';

const useStyles = makeStyles((theme) => ({
  checkbox: {
    '& legend.Mui-focused': {
      color: 'initial',
    },
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
}));

type Props = {
  label: string;
  menuItems: {
    name?: string;
    label: string;
    value: boolean;
  }[];
  error?: string;
  autoFocus?: boolean;
  isErrorVisible?: boolean;
  onFocus?: (event: React.ChangeEvent<HTMLElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLElement>) => void;
  innerRef?: React.MutableRefObject<HTMLInputElement | null>;
};
export const Checkbox: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { errorFont, errorBlock } = useErrorStyles();
  const {
    label,
    menuItems,
    onChange,
    onFocus,
    autoFocus,
    error,
    innerRef,
    isErrorVisible,
  } = props;

  return (
    <FormControl component="fieldset" className={classes.checkbox}>
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup row={true}>
        {menuItems.map((item) => (
          <FormControlLabel
            key={item.name}
            ref={innerRef}
            control={
              <MuiCheckbox
                autoFocus={autoFocus}
                name={item.name ?? item.label}
                value={item.value ?? false}
                checked={item.value ?? false}
                onFocus={onFocus}
                onChange={onChange}
              />
            }
            label={item.label}
          />
        ))}
      </FormGroup>
      {error && isErrorVisible && (
        <FormHelperText className={classNames(errorFont, errorBlock)}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};
